import Vuex from 'vuex'
import Vue from 'vue'

Vue.use(Vuex)

export const store = new Vuex.Store({
  state: {
    // Todas las capas
    layers: null,
    // isDarkTheme ?
    isDarkTheme: true,
    // Lenguaje actual
    locale: null,
    // Error
    error: {
      has: false,
      message: null
    },
    // Info
    info: {
      has: false,
      message: null
    },
    // Está cargando
    isLoading: false,
    // Período seleccionado (Anual por defecto)
    period: 'Anual',
    // Ráster seleccionado
    raster: null,
    /* Controla la visibilidad del menú principal */
    mainMenuOpened: false,
    // Indicadores y capas asociadas a este
    indicadores: {},
    // Indicador seleccionado
    indicador: null,
    // Id del control activo
    activeControlId: null,
    // Lista de polígonos guardados
    savedPolygons: []
  },
  mutations: {

    setLayers(state, layers) {
      state.layers = layers
    },

    setLocale(state, locale) {
      state.locale = locale
    },

    openMenu(state) {
      state.mainMenuOpened = true
    },

    closeMenu(state) {
      state.mainMenuOpened = false
    },

    toggleMenu(state) {
      state.mainMenuOpened = !state.mainMenuOpened
    },
    
    setDarkTheme(state) {
      state.isDarkTheme = true
    },

    setLightTheme(state) {
      state.isDarkTheme = false
    },

    toggleTheme(state) {
      state.isDarkTheme = !state.isDarkTheme
    },

    setError(state, message) {
      state.error.has = true
      state.error.message = message
    },

    clearError(state) {
      state.error.has = false
      state.error.message = null
    },

    setInfo(state, message) {
      state.info.has = true
      state.info.message = message
    },

    clearInfo(state) {
      state.info.has = false
      state.info.message = null
    },

    setLoading(state, value) {
      state.isLoading = !!value
    },

    addIndicador(state, [key, layers]) {
      Vue.set(state.indicadores, key, layers)
    },

    changeIndicador(state, indicador) {
      if(state.indicadores[indicador]) {
        state.indicador = indicador
      }
    },

    setActiveControl(state, controlId) {
      state.activeControlId = controlId
      state.mainMenuOpened = false
    },

    disableControl(state) {
      state.activeControlId = null
      setTimeout(() => state.mainMenuOpened = true, 50)
    },

    addPolygon(state, polygon) {
      //console.log('State Add Polygon', polygon)
      state.savedPolygons = [...state.savedPolygons, polygon]
      localStorage.setItem('saved-polygons', JSON.stringify(state.savedPolygons))
    },

    deletePolygon(state, index) {
      state.savedPolygons.splice(index, 1)
      localStorage.setItem('saved-polygons', JSON.stringify(state.savedPolygons))
    },

    setPeriod(state, period) {
      state.period = period
    },

    setRaster(state, raster) {
      state.raster = raster
    }

  },

  actions: {

    setLayers({commit}, layers) {
      commit('setLayers', layers)
    },

    setLocale({commit}, locale) {
      commit('setLocale', locale)
    },

    setError({ commit }, message) {
      commit('setError', message)
    },

    clearError({commit}) {
      commit('clearError')
    },

    setInfo({ commit }, message) {
      commit('setInfo', message)
    },

    clearInfo({commit}) {
      commit('clearInfo')
    },

    setMap({commit}, map) {
      commit('setMap', map)
    },

    openMenu({commit}) {

      commit('openMenu')
    },

    closeMenu({commit}) {
      commit('closeMenu')
    },

    toggleMenu({commit}) {
      commit('toggleMenu')
    },

    setLoading({commit}, value) {
      commit('setLoading', value)
    },

    addIndicador({commit}, values) {
      commit('addIndicador', values)
    },

    changeIndicador({commit}, indicador) {
      commit('changeIndicador', indicador)
    },

    setActiveControl({commit}, controlId) {
      commit('setActiveControl', controlId)
    },

    disableControl({commit}) {
      commit('disableControl')
    },

    addPolygon({commit}, polygon) {
      commit('addPolygon', polygon)
    },

    deletePolygon({commit}, index) {
      commit('deletePolygon', index)
    },

    setPeriod({commit}, period) {
      commit('setPeriod', period)
    },

    setRaster({commit}, raster) {
      commit('setRaster', raster)
    }

  },

  getters: {
    isDarkTheme: state => state.isDarkTheme,
    hasError: state => state.error.has == true,
    errorMessage: state => state.error.message,
    hasInfo: state => state.info.has == true,
    infoMessage: state => state.info.message,
    map: state => state.map,
    isMainMenuOpened: state => state.mainMenuOpened,
    isLoading: state => state.isLoading,
    indicador: state => state.indicador,
    indicadores: state => state.indicadores,
    activeControlId: state => state.activeControlId,
    savedPolygons: state => state.savedPolygons,
    period: state => state.period,
    raster: state => state.raster,
    locale: state => state.locale,
    indicadoresKeys: state => Object.keys(state.indicadores),
    layers: state => state.layers
  }
})


// WEBPACK FOOTER //
// ./src/store/index.js